import { api } from '../../lib/api.ts';
import type { Body } from '../../lib/body.ts';

export interface Term {
  id: string;
  number: number;
  startDate: string | null;
  endDate: string | null;
  isActive: boolean;
  meetingCount: number;
}

// Every call threads the body: the GET via ?body=, mutations via `body` in the
// request body. `body` defaults to COUNCIL on the server, so omitting it keeps
// council behaviour identical.
export const termsApi = {
  list: (body?: Body) =>
    api.get<{ terms: Term[] }>('/org/terms', { params: body ? { body } : undefined }).then((r) => r.data.terms),
  create: (input: { number: number; startDate?: string; endDate?: string }, body?: Body) =>
    api.post<{ term: Term }>('/org/terms', { ...input, ...(body ? { body } : {}) }).then((r) => r.data.term),
  activate: (id: string, body?: Body) =>
    api.post<{ terms: Term[] }>(`/org/terms/${id}/activate`, body ? { body } : undefined).then((r) => r.data.terms),
  update: (id: string, patch: { number?: number; startDate?: string | null; endDate?: string | null }, body?: Body) =>
    api.patch<{ term: Term }>(`/org/terms/${id}`, { ...patch, ...(body ? { body } : {}) }).then((r) => r.data.term),
  remove: (id: string, body?: Body) =>
    api.delete(`/org/terms/${id}`, body ? { data: { body } } : undefined),
};
